import { gql } from 'urql';

const FetchAccountIDCards = gql`
  query FetchCards {
    cards(
      filter: { status: [NEW, ACTIVATED, LOCKED, NOT_ACTIVATED, SUSPENDED] }
    ) {
      associatedAccountIds
      id
      type
      status
      maskedCardNumber
      isLocked
      isPinSet
      isReplaceable
      associatedAccountIds
      digital
      changePinOptions
      cardHolderName {
        full
      }
      name
      actions
      expiration
    }
  }
`;

export default FetchAccountIDCards;
